import React, { createContext, useContext, useState, useCallback } from 'react';

interface CategoryContextType {
    activeCategory: string | null;
    setActiveCategory: (key: string) => void;
    clearCategory: () => void;
}

const CategoryContext = createContext<CategoryContextType>({} as CategoryContextType);

export const useCategory = () => useContext(CategoryContext);

export const CategoryProvider = ({ children }: { children: React.ReactNode }) => {
    const [activeCategory, setActiveCategoryState] = useState<string | null>(() => {
        // Restore from sessionStorage so a page refresh stays in the same category
        return sessionStorage.getItem('admin_active_category') || null;
    });

    const setActiveCategory = useCallback((key: string) => {
        sessionStorage.setItem('admin_active_category', key);
        setActiveCategoryState(key);
    }, []);

    const clearCategory = useCallback(() => {
        sessionStorage.removeItem('admin_active_category');
        setActiveCategoryState(null);
    }, []);

    return (
        <CategoryContext.Provider value={{ activeCategory, setActiveCategory, clearCategory }}>
            {children}
        </CategoryContext.Provider>
    );
};
